/**
 * Purpose: Format a market offer price in the viewer's locale and the offer's ISO-4217 currency.
 * Inputs: Amount (number or decimal string), currency code, BCP 47 locale.
 * Outputs: A formatted currency string, or null when there is no price to show.
 */

export function formatPrice(
  price: number | string | null | undefined,
  currency: string,
  locale: string,
): string | null {
  // A missing price hides the price on the card rather than rendering zero.
  if (price == null || price === '') return null

  const amount = typeof price === 'number' ? price : Number(price)
  if (!Number.isFinite(amount)) return null

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(amount)
}
